import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { storage } from '../lib/storage';
import enAdmin from './en/admin';
import enAdminCrm from './en/adminCrm';
import enAdminHr from './en/adminHr';
import enAdminOps from './en/adminOps';
import enChat from './en/chat';
import enClient from './en/client';
import enCommon from './en/common';
import enEmployee from './en/employee';
import enPayouts from './en/payouts';
import enPublic from './en/public';
import frAdmin from './fr/admin';
import frAdminCrm from './fr/adminCrm';
import frAdminHr from './fr/adminHr';
import frAdminOps from './fr/adminOps';
import frChat from './fr/chat';
import frClient from './fr/client';
import frCommon from './fr/common';
import frEmployee from './fr/employee';
import frPayouts from './fr/payouts';
import frPublic from './fr/public';

/**
 * i18n from day one: French by default, English available. One namespace per area,
 * and every English file is typed against the French one (compile-time key parity).
 */
export const resources = {
  fr: { common: frCommon, public: frPublic, client: frClient, employee: frEmployee, admin: frAdmin, adminOps: frAdminOps, adminCrm: frAdminCrm, adminHr: frAdminHr, chat: frChat, payouts: frPayouts },
  en: { common: enCommon, public: enPublic, client: enClient, employee: enEmployee, admin: enAdmin, adminOps: enAdminOps, adminCrm: enAdminCrm, adminHr: enAdminHr, chat: enChat, payouts: enPayouts },
} as const;

export type Lang = 'fr' | 'en';
const LANG_KEY = 'menage.lang';

export function initialLanguage(): Lang {
  const saved = storage.get(LANG_KEY);
  return saved === 'en' || saved === 'fr' ? saved : 'fr';
}

export function setLanguage(lang: Lang) {
  storage.set(LANG_KEY, lang);
  document.documentElement.lang = lang;
  void i18n.changeLanguage(lang);
}

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: ['common', 'public', 'client', 'employee', 'admin', 'adminOps', 'adminCrm', 'adminHr', 'chat', 'payouts'],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
